import * as React from 'react';
import { ArticleHeading3 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';

import * as styles from './styles.css';

interface IAdvantageItemProps {
  title: string;
  imgUrl?: string;
}

export function AdvantageItem({ title, imgUrl }: IAdvantageItemProps) {
  const [hovered, setHovered] = React.useState(false);

  const changeHovered = React.useCallback(() => setHovered(!hovered), [hovered]);

  return (
    <div
      className={styles['container']}
      style={{ backgroundImage: `url(${imgUrl})` }}
      onMouseEnter={changeHovered}
      onMouseLeave={changeHovered}
    >
      <div className={styles['title']}>
        <ArticleHeading3 as="h3" color="text-inverted-default">
          {title}
        </ArticleHeading3>
      </div>
      <div className={classNames(styles['arrow'], hovered && styles['arrow-hovered'])}>
        <div className={styles['icon_container']}>
          <IconActionChevronRight16 color={'icon-inverted-default'} />
        </div>
      </div>
    </div>
  );
}
